import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'REGION/LOCATION';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetRegionOfLocation(client, { payload }) {
  try {
    const response = yield client.post('/region/ofLocation', { data: payload });
    yield put(actions.loadSuccess(response.result.region));
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
